module.exports = __webpack_public_path__ + "src/images/mybodymodelheader.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mybodymodelheader.jpg
// module id = 1166
// module chunks = 0